<div class="d-flex flex-row gap-3 flex-nowrap" style="margin-top:15px;">
    <div class="col-1" style="text-align:center;">
        {{ days[(settingsOpenHours.day - 1)].name }}
    </div>
    <div class="col-1">
        Otwarte
        <mat-slide-toggle class="example-margin" [checked]="settingsOpenHours.open" [(ngModel)]="settingsOpenHours.open"
            [disabled]="disabled">
        </mat-slide-toggle>
    </div>
        <mat-form-field appearance="outline">
            <mat-label>od: (xx:xx)</mat-label>
            <input matInput type="text" [(ngModel)]="settingsOpenHours.open_time" (change)="testFromValidation()"
                maxlength="5" timeValidator #timeFrom>
        </mat-form-field>
        <mat-error *ngIf="isValidFrom()">Proszę wprowadzić poprawny czas</mat-error>

        <mat-form-field appearance="outline">
            <mat-label>do: (xx:xx)</mat-label>
            <input matInput type="text" [(ngModel)]="settingsOpenHours.close_time" (change)="testToValidation()"
                maxlength="5" timeValidator #timeTo>
        </mat-form-field>
        <mat-error *ngIf="!validToSignal()">Proszę wprowadzić poprawny czas</mat-error>
</div>